<template>
  <div class="vs-ribbon-item-content">
    <a
      v-if="href && text"
      ref="linkRef"
      :target="linkTarget"
      :rel="linkRel"
      :href="href"
      class="vs-link-cta"
      :aria-label="label"
      :class="{
        'vs-link-new-window': ctaTarget === 'newWindow',
        'vs-link-modal': ctaTarget === 'modalWindow',
        'vs-link-outside': linktype === 'external' && ctaTarget !== 'newWindow',
      }"
      @click="onclick_emit($event)"
    >
      {{ text }}</a>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'VsRibbonItem',
  props: {
    href: { type: String, default: '' },
    text: { type: String, default: '' },
    label: { type: String, default: '' },
    ctaTarget: { type: String, default: '' },
    linktype: { type: String, default: '' },
  },
  data() {
    return {
      touchstartX: 0,
      touchendX: 0,
    };
  },
  computed: {
    linkTarget() {
      return this.ctaTarget === 'newWindow' ? '_blank' : null;
    },
    linkRel() {
      return this.ctaTarget === 'newWindow' ? 'noopener noreferrer' : null;
    },
  },
  mounted() {
    this.$el.addEventListener('keydown', (e) => {
      this.$emit('onKeydown', e);
    });

    this.$el.addEventListener(
      'touchstart',
      (e) => {
        this.touchstartX = e.changedTouches[0].screenX;
      },
      { passive: true }
    );

    this.$el.addEventListener(
      'touchend',
      (e) => {
        this.touchendX = e.changedTouches[0].screenX;
        this.onswipe_gesture();
      },
      { passive: true }
    );
  },
  methods: {
    onclick_emit(e) {
      if (this.$refs.linkRef.classList.contains('vs-active')) {
        e.preventDefault();

        return;
      } else {
        document.dispatchEvent(
          new CustomEvent('click_link_ribbon_nav', {
            detail: {
              href: this.href,
              text: this.text,
            },
          })
        );
      }
    },
    onswipe_gesture() {
      if (this.touchendX < this.touchstartX) {
        this.$emit('onSwipeRight');
      }
      if (this.touchendX > this.touchstartX) {
        this.$emit('onSwipeLeft');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './ribbonItem';
@import '@/styles/core/types/types';
@import '@/styles/links/links';
</style>
